module.exports = __webpack_public_path__ + "media/country_flags/sx-95597fc8.png";